import React from "react";
import PropTypes from "prop-types";
import { getSubchapterImageSrc } from "../../lib/utils";
import styles from "../../styles/columns.module.scss";

const ColumnImage = ({ illustration }) => (
  <div className={styles.columnImage}>
    <img src={getSubchapterImageSrc(illustration)} alt="" />
  </div>
);

ColumnImage.propTypes = {
  illustration: PropTypes.shape({
    illustration: PropTypes.string,
    customSrc: PropTypes.string
  })
};

export default ColumnImage;
